import { initializeApp } from "firebase/app";

var config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};
var secondaryApp = initializeApp(config, "Secondary");
export default secondaryApp;
